const getNode = (elOrRef) => elOrRef?.current || elOrRef

const getNodes = (elements) => _.compact(_.map(elements, getNode))

export default getNodes
